<main class="container mt-5 page" [class.has-floating-schematic]="activeView === 'worksheet' || activeView === 'graph'">
  @if (activeView === 'worksheet' || activeView === 'graph') {
  <aside class="page-floating-schematic-pane">
    <app-pdf-schematic-viewer [pdfUrl]="smartPdfUrl()" [searchQuery]="focusedComponentDesignator()"
      [showControls]="false" [enableDoubleClickPopout]="true" [showPopoutButton]="true"
      [maxFileSizeBytes]="maxSmartPdfUploadSizeBytes" (uploadStarted)="onSmartPdfUploadStarted($event)"
      (uploadSucceeded)="onSmartPdfUploadSucceeded($event)" (uploadFailed)="onSmartPdfUploadFailed($event)"
      (popoutRequested)="openPdfPopout()"></app-pdf-schematic-viewer>
  </aside>
  }

  <section class="workspace">

    <header class="project-header">
      <h2 class="project-name">{{ currentProject()?.name || 'No project selected' }}</h2>
    </header>

    <div class="actions">
      <div class="action">
        <button type="button" class="btn btn-primary" [class.active]="activeView === 'worksheet'"
          (click)="setView('worksheet')">Worksheet</button>
      </div>
      <div class="action">
        <button type="button" class="btn btn-primary" [class.active]="activeView === 'graph'"
          (click)="setView('graph')">Graph</button>
      </div>
      <div class="action">
        <button type="button" class="btn btn-primary" [class.active]="activeView === 'create'"
          (click)="setView('create')">Manage</button>
      </div>
      <div class="action">
        <button type="button" class="btn btn-primary" [class.active]="activeView === 'edit'"
          (click)="setView('edit')">Edit</button>
      </div>
      <!-- 🟢 TEMPORARY UNDO BUTTON -->
      <div class="action">
        <button type="button" class="btn btn-primary" [disabled]="store.isUndoing()" (click)="onUndo()"
          title="Undo last action (Ctrl+Z)">
          @if (store.isUndoing()) {
            Reverting...
          } @else {
            ↩ Undo
          }
        </button>
      </div>
      <div class="action">
        <button type="button" class="btn btn-primary" (click)="refreshData()">Refresh</button>
      </div>
      <div class="action">
        <button type="button" class="btn btn-primary" (click)="seedDemoData()">Seed Demo Data</button>
      </div>
      <div class="action">
        <button type="button" class="btn btn-primary" (click)="openClearDbModal()">Clear DB</button>

      </div>

    </div>

    @if (loading()) {
    <div class="alert alert-info state" role="status">Loading FMEDA data...</div>
    }
    @if (error()) {
    <div class="alert alert-danger state error" role="alert">{{ error() }}</div>
    }
    @if (actionMessage()) {
    <div class="alert alert-success state success" role="status">{{ actionMessage() }}</div>
    }

    @if (activeView === 'worksheet') {
    <article class="panel toolbar-panel">
      <div class="worksheet-toolbar">
        <div class="mini-stat">
          <span>Rows</span>
          <strong>{{ worksheetRows().length }}</strong>
        </div>
        <div class="mini-stat">
          <span>Components</span>
          <strong>{{ worksheetSummary().componentCount }}</strong>
        </div>
        <div class="mini-stat">
          <span>Avg DC</span>
          <strong>{{ worksheetSummary().averageCoveragePct }}%</strong>
        </div>
        <app-netlist-upload [maxFileSizeBytes]="maxNetlistUploadSizeBytes"
          (uploadStarted)="onNetlistUploadStarted($event)" (uploadSucceeded)="onNetlistUploadSucceeded($event)"
          (uploadFailed)="onNetlistUploadFailed($event)"></app-netlist-upload>
      </div>
    </article>
    }

    @if (activeView === 'worksheet') {
    <section class="main-view-shell">
      <div class="split-pane worksheet-pane fill-pane">
        <app-worksheet-view [focusedComponentDesignator]="focusedComponentDesignator()"
          [maxNetlistUploadSizeBytes]="maxNetlistUploadSizeBytes"
          (componentDesignatorSelected)="onWorksheetComponentSelected($event)"
          (componentContextMenuRequested)="onComponentContextMenuRequested($event)"
          (netlistUploadStarted)="onNetlistUploadStarted($event)"
          (netlistUploadSucceeded)="onNetlistUploadSucceeded($event)"
          (netlistUploadFailed)="onNetlistUploadFailed($event)">
        </app-worksheet-view>
      </div>
    </section>
    }

    <!-- ═══════════════════════════════════════════ Graph view ═══ -->
    @if (activeView === 'graph') {
    <section class="main-view-shell">
      <div class="split-pane graph-pane fill-pane">
        @if (activeView === 'graph') {
        <app-graph-view [nodes]="graphData().nodes" [links]="graphData().links" [meta]="graphData().meta"
          [showUnlinkedComponents]="graphShowUnlinkedComponents()"
          [focusedComponentDesignator]="focusedComponentDesignator()" (nodeClicked)="onGraphComponentSelected($event)"
          (linkCreated)="onGraphLinkCreated($event)" (linkDeleted)="onGraphLinkDeleted($event)"
          (showUnlinkedChanged)="onGraphViewConfigChanged()"
          (componentContextMenuRequested)="onComponentContextMenuRequested($event)"
          (failureInstanceRequested)="onFailureInstanceRequested($event)"
          (failureEffectCreated)="onFailureEffectCreated($event)">
          ></app-graph-view>
        }
      </div>
    </section>
    }

    @if (activeView === 'create') {
    <section class="form-view-shell">
      <div class="split-pane">
        <article class="panel create-shell two-col-span create-workspace">
          <header class="create-workspace-header">
            <div class="create-stats">
              <div class="mini-stat">
                <span>Types</span>
                <strong>{{ componentTypes().length }}</strong>
              </div>
              <div class="mini-stat">
                <span>Components</span>
                <strong>{{ components().length }}</strong>
              </div>
              <div class="mini-stat">
                <span>Failure Instances</span>
                <strong>{{ failureInstances().length }}</strong>
              </div>
              <div class="mini-stat">
                <span>Mechanisms</span>
                <strong>{{ safetyMechanisms().length }}</strong>
              </div>
            </div>
          </header>

          <div class="create-nav" role="tablist" aria-label="Create workflow tabs">
            <button type="button" class="btn btn-light" [class.active]="activeCreateTab === 'components'"
              (click)="setCreateTab('components')">Components</button>
            <button type="button" class="btn btn-light" [class.active]="activeCreateTab === 'failure-instances'"
              (click)="setCreateTab('failure-instances')">Failure Instances</button>
            <button type="button" class="btn btn-light" [class.active]="activeCreateTab === 'failure-links'"
              (click)="setCreateTab('failure-links')">Failure Links</button>
            <button type="button" class="btn btn-light" [class.active]="activeCreateTab === 'safety-mechanisms'"
              (click)="setCreateTab('safety-mechanisms')">Safety Mechanisms</button>
            <button type="button" class="btn btn-light" [class.active]="activeCreateTab === 'safety-goals'"
              (click)="setCreateTab('safety-goals')">Safety Goals</button>
            <button type="button" class="btn btn-light" [class.active]="activeCreateTab === 'system-effects'"
              (click)="setCreateTab('system-effects')">System Effects</button>
            <button type="button" class="btn btn-light" [class.active]="activeCreateTab === 'failure-effects'"
              (click)="setCreateTab('failure-effects')">Failure Effects</button>
          </div>

          <div class="create-content-grid">
            <article class="panel inner-panel create-list-panel">
              <div class="create-list-toolbar">
                <label class="create-list-search">
                  <span>Filter created items</span>
                  <input type="search" [ngModel]="createListSearch" [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onCreateListSearchChange($event)" placeholder="Search id, name, designator..." />
                </label>
                <div class="create-list-actions">
                  <button type="button" class="btn btn-light" (click)="toggleCreateListSortDirection()">
                    Sort {{ createListSortDirection === 'asc' ? 'A → Z' : 'Z → A' }}
                  </button>
                </div>
              </div>
              <div class="create-list-heading">
                <h2>{{ getActiveCreateTabHeading() }}</h2>
                <a href="javascript:void(0)" class="create-add-btn" placement="end" ngbTooltip="Create new"
                  (click)="openCreateEntityDialog()">+</a>
              </div>

              @if (activeCreateTab === 'component-types') {
              @if (filteredCreateComponentTypes.length) {
              <ul class="item-list compact-list create-list">
                @for (type of filteredCreateComponentTypes; track type) {
                <li>
                  <div class="create-list-row">
                    <div>
                      <strong>{{ type.name }}</strong>
                      <small>{{ type.failure_modes.length }} failure mode(s)</small>
                    </div>
                    <button type="button" class="btn btn-light btn-sm" disabled>Edit</button>
                  </div>
                </li>
                }
              </ul>
              } @else if (componentTypes().length) {
              <p class="hint">No component types match the current filter.</p>
              } @else {
              <p class="hint">No component types created yet.</p>
              }
              }

              @if (activeCreateTab === 'components') {
              @if (filteredCreateComponents.length) {
              <ul class="item-list compact-list create-list">
                @for (component of filteredCreateComponents; track component) {
                <li class="create-list-item--editable"
                  (dblclick)="openCreateComponentEditDialog(component.component_designator)">
                  <div class="create-list-row">
                    <div>
                      <strong>{{ component.component_designator }}</strong>
                      <small>Type: {{ component.component_type || 'Unassigned' }} · Temp: {{ component.op_temp ?? 25 }}
                        °C</small>
                    </div>
                    <button type="button" class="btn btn-light btn-sm"
                      (click)="openCreateComponentEditDialog(component.component_designator)">Edit</button>
                  </div>
                </li>
                }
              </ul>
              } @else if (components().length) {
              <p class="hint">No components match the current filter.</p>
              } @else {
              <p class="hint">No components created yet.</p>
              }
              }

              @if (activeCreateTab === 'failure-instances') {
              @if (filteredCreateFailureInstances.length) {
              <ul class="item-list compact-list create-list">
                @for (fi of filteredCreateFailureInstances; track fi) {
                <li class="create-list-item--editable" (dblclick)="openCreateListFailureInstanceEditor(fi.id)">
                  <div class="create-list-row">
                    <div>
                      <strong>{{ fi.id }} · {{ fi.name }}</strong>
                      <small>{{ fi.component_designator }} · {{ fi.failure_mode_code }} · FE {{ fi.failure_effect_id ||
                        'unlinked' }}</small>
                    </div>
                    <button type="button" class="btn btn-light btn-sm"
                      (click)="openCreateListFailureInstanceEditor(fi.id)">Edit</button>
                  </div>
                </li>
                }
              </ul>
              } @else if (failureInstances().length) {
              <p class="hint">No failure instances match the current filter.</p>
              } @else {
              <p class="hint">No failure instances created yet.</p>
              }
              }

              @if (activeCreateTab === 'failure-links') {
              @if (filteredCreateFailureInstances.length) {
              <ul class="item-list compact-list create-list">
                @for (fi of filteredCreateFailureInstances; track fi) {
                <li class="create-list-item--editable" (dblclick)="openCreateListFailureLinkEditor(fi.id)">
                  <div class="create-list-row">
                    <div>
                      <strong>{{ fi.id }} · {{ fi.component_designator }} · {{ fi.failure_mode_code }}</strong>
                      <small>FE: {{ fi.failure_effect_id || 'none' }} · SE: {{ fi.system_effect_id || 'none' }} · SG:
                        {{ fi.safety_goal_id || 'none' }}</small>
                    </div>
                    <button type="button" class="btn btn-light btn-sm"
                      (click)="openCreateListFailureLinkEditor(fi.id)">Edit</button>
                  </div>
                </li>
                }
              </ul>
              } @else if (failureInstances().length) {
              <p class="hint">No failure links match the current filter.</p>
              } @else {
              <p class="hint">No linked failure chains created yet.</p>
              }
              }

              @if (activeCreateTab === 'safety-mechanisms') {
              @if (filteredCreateSafetyMechanisms.length) {
              <ul class="item-list compact-list create-list">
                @for (mechanism of filteredCreateSafetyMechanisms; track mechanism) {
                <li class="create-list-item--editable" (dblclick)="openCreateListSafetyMechanismEditor(mechanism.id)">
                  <div class="create-list-row">
                    <div>
                      <strong>{{ mechanism.id }} · {{ mechanism.name }}</strong>
                      <small>{{ mechanism.mechanism_type }} · Linked failures: {{ mechanism.failure_instance_ids.length
                        +
                        mechanism.latent_failure_instance_ids.length }}</small>
                    </div>
                    <button type="button" class="btn btn-light btn-sm"
                      (click)="openCreateListSafetyMechanismEditor(mechanism.id)">Edit</button>
                  </div>
                </li>
                }
              </ul>
              } @else if (safetyMechanisms().length) {
              <p class="hint">No safety mechanisms match the current filter.</p>
              } @else {
              <p class="hint">No safety mechanisms created yet.</p>
              }
              }

              @if (activeCreateTab === 'safety-goals') {
              @if (filteredCreateSafetyGoals.length) {
              <ul class="item-list compact-list create-list">
                @for (goal of filteredCreateSafetyGoals; track goal) {
                <li>
                  <div class="create-list-row">
                    <div>
                      <strong>{{ goal.id }}</strong>
                      <small>{{ goal.description }}</small>
                    </div>
                    <button type="button" class="btn btn-light btn-sm" disabled>Edit</button>
                  </div>
                </li>
                }
              </ul>
              } @else if (safetyGoals().length) {
              <p class="hint">No safety goals match the current filter.</p>
              } @else {
              <p class="hint">No safety goals created yet.</p>
              }
              }

              @if (activeCreateTab === 'system-effects') {
              @if (filteredCreateSystemEffects.length) {
              <ul class="item-list compact-list create-list">
                @for (effect of filteredCreateSystemEffects; track effect) {
                <li class="create-list-item--editable" (dblclick)="openCreateListSystemEffectEditor(effect.id)">
                  <div class="create-list-row">
                    <div>
                      <strong>{{ effect.id }} · {{ effect.name }}</strong>
                      <small>Safety goal: {{ effect.safety_goal_id || 'none' }}</small>
                    </div>
                    <button type="button" class="btn btn-light btn-sm"
                      (click)="openCreateListSystemEffectEditor(effect.id)">Edit</button>
                  </div>
                </li>
                }
              </ul>
              } @else if (systemEffects().length) {
              <p class="hint">No system effects match the current filter.</p>
              } @else {
              <p class="hint">No system effects created yet.</p>
              }
              }

              @if (activeCreateTab === 'failure-effects') {
              @if (filteredCreateFailureEffects.length) {
              <ul class="item-list compact-list create-list">
                @for (effect of filteredCreateFailureEffects; track effect) {
                <li class="create-list-item--editable" (dblclick)="openCreateListFailureEffectEditor(effect.id)">
                  <div class="create-list-row">
                    <div>
                      <strong>{{ effect.id }} · {{ effect.name }}</strong>
                      <small>System effect: {{ effect.system_effect_id || 'none' }}</small>
                    </div>
                    <button type="button" class="btn btn-light btn-sm"
                      (click)="openCreateListFailureEffectEditor(effect.id)">Edit</button>
                  </div>
                </li>
                }
              </ul>
              } @else if (failureEffects().length) {
              <p class="hint">No failure effects match the current filter.</p>
              } @else {
              <p class="hint">No failure effects created yet.</p>
              }
              }
            </article>
          </div>
        </article>
      </div>
    </section>
    }

    @if (activeView === 'edit') {
    <section class="form-view-shell">
      <div class="split-pane">
        <div class="forms-grid">
          <article class="panel two-col-span assign-panel">
            <div class="assign-type-shell">
              <section class="assign-browser">
                <div class="assign-browser-header">
                  <div>
                    <h2>Assign Component Type</h2>
                    <p class="hint">Search components, inspect imported netlist data, and optionally apply the same
                      type
                      to identical parts.</p>
                  </div>
                  <label class="assign-search">
                    <span>Search components</span>
                    <input type="search" [ngModel]="assignTypeSearch" [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="onAssignTypeSearchChange($event)"
                      placeholder="Search by refdes, type, package, or part number" />
                  </label>
                </div>
                @if (filteredAssignableComponents.length) {
                <ul class="item-list assign-results">
                  @for (component of filteredAssignableComponents; track component) {
                  <li
                    [class.selected]="component.component_designator === assignTypeForm.controls.componentDesignator.value">
                    <button type="button" class="item-btn assign-result-btn"
                      (click)="selectAssignableComponent(component.component_designator)"
                      (contextmenu)="onAssignableComponentContextMenu($event, component.component_designator)">
                      <span>
                        <strong>{{ component.component_designator }}</strong>
                        <small>{{ component.component_type ??
                          'Unassigned'
                          }}</small>
                      </span>
                      <small>{{ component.part_number || 'No part number' }}</small>
                    </button>
                    <div class="assign-result-meta">
                      <small>Package: {{ component.package || 'Not available' }}</small>
                      <small>Manufacturer part number: {{ component.part_number || 'Not available' }}</small>
                      <small>Failure instances: {{ component.failure_instance_count }}</small>
                    </div>
                  </li>
                  }
                </ul>
                } @else {
                <p class="hint">No components match the current search.</p>
                }
              </section>
              <section class="assign-editor">
                <form [formGroup]="assignTypeForm" (ngSubmit)="assignComponentType()" class="form-stack">
                  @if (selectedAssignableComponent; as component) {
                  <div class="assign-detail-card">
                    <div class="assign-detail-header">
                      <div>
                        <h3>{{ component.component_designator }}</h3>
                        <p class="hint">{{ component.component_designator || component.component_designator }}</p>
                      </div>
                      <span class="assign-status" [class.assigned]="component.component_type">
                        {{ component.component_type ?? 'Unassigned' }}
                      </span>
                    </div>
                    <div class="assign-detail-grid">
                      <div>
                        <span class="detail-label">Manufacturer part number</span>
                        <strong>{{ component.part_number || 'Not available' }}</strong>
                      </div>
                      <div>
                        <span class="detail-label">Package</span>
                        <strong>{{ component.package || 'Not available' }}</strong>
                      </div>
                      <div>
                        <span class="detail-label">Current type</span>
                        <strong>{{ component.component_type || 'Unassigned' }}</strong>
                      </div>
                      <div>
                        <span class="detail-label">Current temperature</span>
                        <strong>{{ component.op_temp ?? 25 }} °C</strong>
                      </div>
                    </div>
                  </div>
                  <label>
                    <span>Component type</span>
                    <select formControlName="componentTypeName">
                      <option value="">Select component type</option>
                      @for (type of componentTypes(); track type) {
                      <option [value]="type.name">{{ type.name }}</option>
                      }
                    </select>
                  </label>
                  <label>
                    <span>Operating temp (°C)</span>
                    <input type="number" step="0.1" formControlName="opTemp" placeholder="25" />
                  </label>
                  @if (identicalAssignableComponents.length) {
                  <div class="identical-parts">
                    <div class="identical-parts-header">
                      <div>
                        <h3>Identical Parts</h3>
                        <p class="hint">Matched on manufacturer part number and package.</p>
                      </div>
                      <label class="inline-check">
                        <input type="checkbox" [checked]="areAllIdenticalPartsSelected()"
                          (change)="toggleAllIdenticalParts($any($event.target).checked)" />
                        <span>Select all</span>
                      </label>
                    </div>
                    <ul class="item-list compact-list identical-parts-list assign-results">
                      @for (identical of identicalAssignableComponents; track identical) {
                      <li>
                        <label class="identical-part-option">
                          <input type="checkbox"
                            [ngModel]="isIdenticalComponentSelected(identical.component_designator)"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="toggleIdenticalComponent(identical.component_designator, $event)" />
                          <span>
                            <strong>{{ identical.component_designator }}</strong>
                            <small>· {{ identical.component_type ?? 'Unassigned' }}</small>
                          </span>
                        </label>
                      </li>
                      }
                    </ul>
                  </div>
                  } @else {
                  <p class="hint">No identical parts were found for this component.</p>
                  }
                  <button type="submit" class="btn btn-primary">
                    Assign Type to {{ selectedAssignableTargetCount }} Component{{ selectedAssignableTargetCount ===
                    1
                    ? '' : 's' }}
                  </button>
                  } @else {
                  <p class="hint">Select a component from the list to inspect its imported data and assign a type.
                  </p>
                  }
                </form>
              </section>
            </div>
          </article>
          <article class="panel">
            <h2>Edit Component Temperature</h2>
            <form [formGroup]="editComponentForm" (ngSubmit)="updateComponentTemp()" class="form-stack">
              <label>
                <span>Component</span>
                <select formControlName="componentDesignator">
                  <option value="">Select component</option>
                  @for (component of components(); track component) {
                  <option [value]="component.component_designator">
                    {{ component.component_designator }} ({{ component.component_type ?? 'unassigned' }})
                  </option>
                  }
                </select>
              </label>
              <input type="number" step="0.1" formControlName="opTemp" placeholder="Operating temp" />
              <button type="submit" class="btn btn-primary">Update Temperature</button>
            </form>
          </article>
          <article class="panel">
            <h2>Edit Diagnostic Coverage</h2>
            <form [formGroup]="editCoverageForm" (ngSubmit)="updateCoverage()" class="form-stack">
              <label>
                <span>Coverage link</span>
                <select formControlName="coverageLinkKey" (change)="syncCoverageSelection()"
                  (contextmenu)="onCoverageContextMenu($event)">
                  <option value="">Select existing coverage link</option>
                  @for (link of coverageLinks(); track link) {
                  <option [value]="link.safety_mechanism_id + '::' + link.failure_instance_id">
                    {{ link.safety_mechanism_id }} -> {{ link.failure_instance_id }}
                  </option>
                  }
                </select>
              </label>
              <input type="text" formControlName="safetyMechanismId" placeholder="Safety mechanism id" readonly />
              <input type="text" formControlName="failureInstanceId" placeholder="Failure instance id" readonly />
              <input type="number" step="0.01" min="0" max="1" formControlName="diagnosticCoverage"
                placeholder="Diagnostic coverage" />
              <button type="submit" class="btn btn-primary">Update Coverage</button>
            </form>
          </article>
          <article class="panel">
            <h2>Edit Failure Effect &rarr; System Effect</h2>
            <form [formGroup]="editFeLink" (ngSubmit)="updateFailureEffectLink()" class="form-stack">
              <label>
                <span>Failure Effect</span>
                <select formControlName="failureEffectId" (change)="syncFeLinkSelection()"
                  (contextmenu)="onFailureEffectLinkContextMenu($event)">
                  <option value="">Select failure effect</option>
                  @for (fe of failureEffects(); track fe) {
                  <option [value]="fe.id">
                    {{ fe.id }} - {{ fe.name }}
                    @if (fe.system_effect_id) {
                    &rarr; {{ fe.system_effect_id }}
                    }
                  </option>
                  }
                </select>
              </label>
              <label>
                <span>New target System Effect</span>
                <select formControlName="systemEffectId">
                  <option value="">None (remove link)</option>
                  @for (se of systemEffects(); track se) {
                  <option [value]="se.id">
                    {{ se.id }} - {{ se.name }}
                  </option>
                  }
                </select>
              </label>
              <button type="submit" class="btn btn-primary">Update FE Link</button>
            </form>
          </article>
          <article class="panel">
            <h2>Edit System Effect &rarr; Safety Goal</h2>
            <form [formGroup]="editSeLink" (ngSubmit)="updateSystemEffectLink()" class="form-stack">
              <label>
                <span>System Effect</span>
                <select formControlName="systemEffectId" (change)="syncSeLinkSelection()"
                  (contextmenu)="onSystemEffectLinkContextMenu($event)">
                  <option value="">Select system effect</option>
                  @for (se of systemEffects(); track se) {
                  <option [value]="se.id">
                    {{ se.id }} - {{ se.name }}
                    @if (se.safety_goal_id) {
                    &rarr; {{ se.safety_goal_id }}
                    }
                  </option>
                  }
                </select>
              </label>
              <label>
                <span>New target Safety Goal</span>
                <select formControlName="safetyGoalId">
                  <option value="">None (remove link)</option>
                  @for (sg of safetyGoals(); track sg) {
                  <option [value]="sg.id">
                    {{ sg.id }} - {{ sg.description }}
                  </option>
                  }
                </select>
              </label>
              <button type="submit" class="btn btn-primary">Update SE Link</button>
            </form>
          </article>
          <article class="panel">
            <h2>Edit Failure Instance &rarr; Failure Effect</h2>
            <form [formGroup]="editFiCause" (ngSubmit)="updateFailureInstanceCause()" class="form-stack">
              <label>
                <span>Failure Instance</span>
                <select formControlName="failureInstanceId" (change)="syncFiCauseSelection()"
                  (contextmenu)="onFailureInstanceCauseContextMenu($event)">
                  <option value="">Select failure instance</option>
                  @for (fi of failureInstances(); track fi) {
                  <option [value]="fi.id">
                    {{ fi.id }} - {{ fi.name }}
                    @if (fi.failure_effect_id) {
                    &rarr; {{ fi.failure_effect_id }}
                    }
                  </option>
                  }
                </select>
              </label>
              <label>
                <span>New target Failure Effect</span>
                <select formControlName="failureEffectId">
                  <option value="">None (remove link)</option>
                  @for (fe of failureEffects(); track fe) {
                  <option [value]="fe.id">
                    {{ fe.id }} - {{ fe.name }}
                  </option>
                  }
                </select>
              </label>
              <button type="submit" class="btn btn-primary">Update FI Cause</button>
            </form>
          </article>
          <article class="panel">
            <h2>Component Types (Reference)</h2>
            <ul class="item-list">
              @for (type of componentTypes(); track type) {
              <li>
                <strong>{{ type.name }}</strong>
                <small>{{ type.failure_modes.length }} failure modes</small>
              </li>
              }
            </ul>
          </article>
        </div>
      </div>
    </section>
    }

  </section>
</main>

@if (showComponentContextMenu()) {
<div class="component-context-menu" [style.left.px]="contextMenuPosition().x" [style.top.px]="contextMenuPosition().y"
  (click)="$event.stopPropagation()">
  @for (action of contextMenuActions(); track action) {
  <button type="button" class="component-context-menu-item" (click)="onContextMenuActionSelected(action.id)">
    {{ action.label }}
  </button>
  }
</div>
}

@if (showAssignTypeDialog()) {
<div class="modal" (click)="closeAssignTypeDialog()">
  <div class="modal-content modal-content--wide" (click)="$event.stopPropagation()">
    <h2>Assign Component Type</h2>
    <section class="assign-editor">
      <form [formGroup]="assignTypeForm" (ngSubmit)="assignComponentType()" class="form-stack">
        @if (selectedAssignableComponent; as component) {
        <div class="assign-detail-card">
          <div class="assign-detail-header">
            <div>
              <h3>{{ component.component_designator }}</h3>
              <p class="hint">Assign a type to this component and optionally to identical parts.</p>
            </div>
            <span class="assign-status" [class.assigned]="component.component_type">
              {{ component.component_type ?? 'Unassigned' }}
            </span>
          </div>
          <div class="assign-detail-grid">
            <div>
              <span class="detail-label">Manufacturer part number</span>
              <strong>{{ component.part_number || 'Not available' }}</strong>
            </div>
            <div>
              <span class="detail-label">Package</span>
              <strong>{{ component.package || 'Not available' }}</strong>
            </div>
            <div>
              <span class="detail-label">Current type</span>
              <strong>{{ component.component_type || 'Unassigned' }}</strong>
            </div>
            <div>
              <span class="detail-label">Current temperature</span>
              <strong>{{ component.op_temp ?? 25 }} °C</strong>
            </div>
          </div>
        </div>

        <label>
          <span>Component type</span>
          <select formControlName="componentTypeName">
            <option value="">Select component type</option>
            @for (type of componentTypes(); track type) {
            <option [value]="type.name">{{ type.name }}</option>
            }
          </select>
        </label>

        <label>
          <span>Operating temp (°C)</span>
          <input type="number" step="0.1" formControlName="opTemp" placeholder="25" />
        </label>

        @if (identicalAssignableComponents.length) {
        <div class="identical-parts">
          <div class="identical-parts-header">
            <div>
              <h3>Identical Parts</h3>
              <p class="hint">Matched on manufacturer part number and package.</p>
            </div>
            <label class="inline-check">
              <input type="checkbox" [checked]="areAllIdenticalPartsSelected()"
                (change)="toggleAllIdenticalParts($any($event.target).checked)" />
              <span>Select all</span>
            </label>
          </div>
          <ul class="item-list compact-list identical-parts-list assign-results">
            @for (identical of identicalAssignableComponents; track identical) {
            <li>
              <label class="identical-part-option">
                <input type="checkbox" [ngModel]="isIdenticalComponentSelected(identical.component_designator)"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="toggleIdenticalComponent(identical.component_designator, $event)" />
                <span>
                  <strong>{{ identical.component_designator }}</strong>
                  <small>· {{ identical.component_type ?? 'Unassigned' }}</small>
                </span>
              </label>
            </li>
            }
          </ul>
        </div>
        } @else {
        <p class="hint">No identical parts were found for this component.</p>
        }

        <div class="modal-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="closeAssignTypeDialog()">Cancel</button>
          <button type="submit" class="btn btn-primary">
            Assign Type to {{ selectedAssignableTargetCount }} Component{{ selectedAssignableTargetCount === 1 ? '' :
            's' }}
          </button>
        </div>
        } @else {
        <p class="hint">Selected component is no longer available.</p>
        <div class="modal-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="closeAssignTypeDialog()">Close</button>
        </div>
        }
      </form>
    </section>
  </div>
</div>
}

@if (showAddFailureInstanceDialog()) {
<div class="modal" (click)="closeAddFailureInstanceDialog()">
  <div class="modal-content modal-content--compact" (click)="$event.stopPropagation()">
    <h2>Add Failure Instance</h2>
    <form [formGroup]="createFailureInstanceForm" (ngSubmit)="createFailureInstance()" class="form-stack">
      <label>
        <span>Component</span>
        <select formControlName="componentDesignator" (change)="syncFailureInstanceModeOptions()">
          <option value="">Select component</option>
          @for (component of assignedComponents(); track component) {
          <option [value]="component.component_designator">{{ component.component_designator }} ({{
            component.component_type }}) - {{ businessLogic.getRemainingFailureModeCount(component.component_designator)
            }} remaining</option>
          }
        </select>
      </label>
      <label>
        <span>Failure mode</span>
        <select formControlName="failureModeCode" (change)="onCreateFailureInstanceModeChanged()">
          <option value="">Select remaining failure mode</option>
          @for (mode of
          businessLogic.getRemainingFailureModesForComponent(createFailureInstanceForm.controls.componentDesignator.value);
          track mode) {
          <option [value]="mode.code">{{ mode.code }} - {{ mode.name }}</option>
          }
        </select>
      </label>
      <div class="inline-select-action">
        <label>
          <span>Failure Effect</span>
          <select formControlName="failureEffectId" (change)="onCreateFailureInstanceFailureEffectChanged()">
            <option value="">Select failure effect (optional)</option>
            @for (effect of failureEffects(); track effect) {
            <option [value]="effect.id">{{ effect.id }} - {{ effect.name }}</option>
            }
          </select>
        </label>
        <button type="button" class="btn btn-outline-secondary"
          (click)="openCreateFailureEffectDialogFromFailureInstance()">+</button>
      </div>
      <div class="inline-select-action">
        <label>
          <span>System Effect</span>
          <select formControlName="systemEffectId">
            <option value="">Select system effect (optional)</option>
            @for (effect of systemEffects(); track effect) {
            <option [value]="effect.id">{{ effect.id }} - {{ effect.name }}</option>
            }
          </select>
        </label>
        <button type="button" class="btn btn-outline-secondary"
          (click)="openCreateSystemEffectDialogFromFailureInstance()">+</button>
      </div>
      <label>
        <span>Failure instance id (optional)</span>
        <input type="text" formControlName="fiId" [placeholder]="idSuggestions().failure_instance_id" />
      </label>
      <input type="text" formControlName="fiName" placeholder="Auto-filled (COMPONENT_MODE_EVENT)" />
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary"
          (click)="closeAddFailureInstanceDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Create Failure Instance</button>
      </div>
    </form>
  </div>
</div>
}

@if (showCreateEntityDialog()) {
<div class="modal" (click)="closeCreateEntityDialog()">
  <div class="modal-content modal-content--wide" (click)="$event.stopPropagation()">
    <h2>{{ getCreateDialogHeading() }}</h2>

    @if (createDialogMode === 'create' && activeCreateTab === 'component-types') {
    <form [formGroup]="createComponentTypeForm" (ngSubmit)="createComponentType()" class="form-stack">
      <input type="text" formControlName="name" placeholder="Component type name" />
      <div class="failure-mode-list" formArrayName="failureModes">
        @for (failureModeGroup of createComponentTypeFailureModes.controls; track failureModeGroup; let i = $index) {
        <article class="failure-mode-item" [formGroupName]="i">
          <header class="failure-mode-header">
            <h3>Failure Mode {{ i + 1 }}</h3>
            <button type="button" class="btn btn-outline-secondary" (click)="removeCreateTypeFailureMode(i)"
              [disabled]="createComponentTypeFailureModes.length === 1">Remove</button>
          </header>
          <input type="text" formControlName="code" placeholder="Failure mode code" />
          <input type="text" formControlName="failureModeName" placeholder="Failure mode name" />
          <label>
            <span>Thermal model</span>
            <select formControlName="thermalModelId">
              <option value="">Select thermal model</option>
              @for (thermalModel of thermalModels(); track thermalModel) {
              <option [value]="thermalModel.id">{{ thermalModel.id }} (Ea {{ thermalModel.ea }})</option>
              }
            </select>
          </label>
          <input type="number" step="0.01" formControlName="baseRateValue" placeholder="Base rate" />
          <input type="text" formControlName="baseRateUnit" placeholder="Base rate unit" />
          <label>
            <span>Standard</span>
            <select formControlName="standardName">
              <option value="">Select standard</option>
              @for (standard of standards(); track standard) {
              <option [value]="standard.name">{{ standard.name }} ({{ standard.revision }})</option>
              }
            </select>
          </label>
        </article>
        }
      </div>
      <div class="modal-actions modal-actions--spread">
        <button type="button" class="btn btn-outline-secondary" (click)="addCreateTypeFailureMode()">Add Failure
          Mode</button>
        <div class="modal-action-group">
          <button type="button" class="btn btn-outline-secondary" (click)="closeCreateEntityDialog()">Cancel</button>
          <button type="submit" class="btn btn-primary">Create Type</button>
        </div>
      </div>
    </form>
    }

    @if (createDialogMode === 'create' && activeCreateTab === 'components') {
    <form [formGroup]="createComponentForm" (ngSubmit)="createComponent()" class="form-stack">
      <input type="text" formControlName="componentDesignator" placeholder="Designator (U2)" />
      <label>
        <span>Component type</span>
        <select formControlName="componentTypeName">
          <option value="">Select component type</option>
          @for (type of componentTypes(); track type) {
          <option [value]="type.name">{{ type.name }}</option>
          }
        </select>
      </label>
      <input type="number" step="0.1" formControlName="opTemp" placeholder="Operating temp" />
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="closeCreateEntityDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Create Component</button>
      </div>
    </form>
    }

    @if (createDialogMode === 'edit' && activeCreateTab === 'components') {
    <form [formGroup]="assignTypeForm" (ngSubmit)="assignComponentType()" class="form-stack">
      <label>
        <span>Component</span>
        <input type="text" formControlName="componentDesignator" readonly />
      </label>
      <label>
        <span>Component type</span>
        <select formControlName="componentTypeName">
          <option value="">Select component type</option>
          @for (type of componentTypes(); track type) {
          <option [value]="type.name">{{ type.name }}</option>
          }
        </select>
      </label>
      <label>
        <span>Operating temp (°C)</span>
        <input type="number" step="0.1" formControlName="opTemp" placeholder="25" />
      </label>
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="closeCreateEntityDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Save Component</button>
      </div>
    </form>
    }

    @if (createDialogMode === 'create' && activeCreateTab === 'failure-instances') {
    <form [formGroup]="createFailureInstanceForm" (ngSubmit)="createFailureInstance()" class="form-stack">
      <label>
        <span>Component</span>
        <select formControlName="componentDesignator" (change)="syncFailureInstanceModeOptions()">
          <option value="">Select component</option>
          @for (component of assignedComponents(); track component) {
          <option [value]="component.component_designator">{{ component.component_designator }} ({{
            component.component_type }}) - {{ businessLogic.getRemainingFailureModeCount(component.component_designator)
            }} remaining</option>
          }
        </select>
      </label>
      <label>
        <span>Failure mode</span>
        <select formControlName="failureModeCode" (change)="onCreateFailureInstanceModeChanged()">
          <option value="">Select remaining failure mode</option>
          @for (mode of
          businessLogic.getRemainingFailureModesForComponent(createFailureInstanceForm.controls.componentDesignator.value);
          track mode) {
          <option [value]="mode.code">{{ mode.code }} - {{ mode.name }}</option>
          }
        </select>
      </label>
      <label>
        <span>Failure instance id (optional)</span>
        <input type="text" formControlName="fiId" [placeholder]="idSuggestions().failure_instance_id" />
      </label>
      <input type="text" formControlName="fiName" placeholder="Auto-filled (COMPONENT_MODE_EVENT)" />
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="closeCreateEntityDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Create Failure Instance</button>
      </div>
    </form>
    }

    @if (createDialogMode === 'create' && activeCreateTab === 'failure-links') {
    <form [formGroup]="createFailureLinkForm" (ngSubmit)="createFailureLink()" class="form-stack">
      <label>
        <span>Component</span>
        <select formControlName="componentDesignator" (change)="syncFailureModeOptions()">
          <option value="">Select component</option>
          @for (component of assignedComponents(); track component) {
          <option [value]="component.component_designator">{{ component.component_designator }} ({{
            component.component_type }}) - {{ businessLogic.getRemainingFailureModeCount(component.component_designator)
            }} remaining</option>
          }
        </select>
      </label>
      <label>
        <span>Failure mode</span>
        <select formControlName="failureModeCode" (change)="onCreateFailureLinkModeChanged()">
          <option value="">Select remaining failure mode</option>
          @for (mode of
          businessLogic.getRemainingFailureModesForComponent(createFailureLinkForm.controls.componentDesignator.value);
          track mode) {
          <option [value]="mode.code">{{ mode.code }} - {{ mode.name }}</option>
          }
        </select>
      </label>
      <label>
        <span>Failure effect</span>
        <select formControlName="failureEffectId" (change)="syncFailureEffectSystemEffect()">
          <option value="">Select failure effect</option>
          @for (effect of failureEffects(); track effect) {
          <option [value]="effect.id">{{ effect.id }} - {{ effect.name }}</option>
          }
        </select>
      </label>
      <label>
        <span>System effect</span>
        <select formControlName="systemEffectId">
          <option value="">Optional system effect override</option>
          @for (effect of systemEffects(); track effect) {
          <option [value]="effect.id">{{ effect.id }} - {{ effect.name }}</option>
          }
        </select>
      </label>
      <label>
        <span>Failure instance id (optional)</span>
        <input type="text" formControlName="fiId" [placeholder]="idSuggestions().failure_instance_id" />
      </label>
      <input type="text" formControlName="fiName" placeholder="Auto-filled (COMPONENT_MODE_EVENT)" />
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="closeCreateEntityDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Create Failure Link</button>
      </div>
    </form>
    }

    @if (createDialogMode === 'create' && activeCreateTab === 'safety-mechanisms') {
    <form [formGroup]="createSafetyMechanismForm" (ngSubmit)="createSafetyMechanism()" class="form-stack">
      <label>
        <span>Safety mechanism id (optional)</span>
        <input type="text" formControlName="smId" [placeholder]="idSuggestions().safety_mechanism_id" />
      </label>
      <input type="text" formControlName="name" placeholder="Mechanism name" />
      <label>
        <span>Mechanism type</span>
        <select formControlName="mechanismType">
          <option value="SPF">Primary (SPF)</option>
          <option value="LATENT">Secondary (Latent)</option>
        </select>
      </label>
      <label>
        <span>Failure instance</span>
        <select formControlName="failureInstanceId">
          <option value="">Select failure instance</option>
          @for (failureInstance of failureInstances(); track failureInstance) {
          <option [value]="failureInstance.id">{{ failureInstance.id }} - {{ failureInstance.name }}</option>
          }
        </select>
      </label>
      <input type="number" step="0.01" min="0" max="1" formControlName="diagnosticCoverage"
        placeholder="Diagnostic coverage" />
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="closeCreateEntityDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Create Mechanism</button>
      </div>
    </form>
    }

    @if (createDialogMode === 'create' && activeCreateTab === 'safety-goals') {
    <form [formGroup]="createSafetyGoalForm" (ngSubmit)="createSafetyGoal()" class="form-stack">
      <label>
        <span>Safety goal id (optional)</span>
        <input type="text" formControlName="id" [placeholder]="idSuggestions().safety_goal_id" />
      </label>
      <textarea formControlName="description" rows="4" placeholder="Safety goal description"></textarea>
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="closeCreateEntityDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Create Safety Goal</button>
      </div>
    </form>
    }

    @if (createDialogMode === 'create' && activeCreateTab === 'system-effects') {
    <form [formGroup]="createSystemEffectForm" (ngSubmit)="createSystemEffect()" class="form-stack">
      <label>
        <span>System effect id (optional)</span>
        <input type="text" formControlName="id" [placeholder]="idSuggestions().system_effect_id" />
      </label>
      <input type="text" formControlName="name" placeholder="System effect name" />
      <label>
        <span>Violates safety goal</span>
        <select formControlName="safetyGoalId">
          <option value="">No linked safety goal</option>
          @for (goal of safetyGoals(); track goal) {
          <option [value]="goal.id">{{ goal.id }} - {{ goal.description }}</option>
          }
        </select>
      </label>
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="closeCreateEntityDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Create System Effect</button>
      </div>
    </form>
    }

    @if (createDialogMode === 'create' && activeCreateTab === 'failure-effects') {
    <form [formGroup]="createFailureEffectForm" (ngSubmit)="createFailureEffect()" class="form-stack">
      <label>
        <span>Failure effect id (optional)</span>
        <input type="text" formControlName="id" [placeholder]="idSuggestions().failure_effect_id" />
      </label>
      <input type="text" formControlName="name" placeholder="Failure effect name" />
      <div class="inline-select-action">
        <label>
          <span>Leads to system effect</span>
          <select formControlName="systemEffectId">
            <option value="">No linked system effect</option>
            @for (effect of systemEffects(); track effect) {
            <option [value]="effect.id">{{ effect.id }} - {{ effect.name }}</option>
            }
          </select>
        </label>
        <button type="button" class="btn btn-outline-secondary"
          (click)="openCreateSystemEffectDialogFromFailureEffect()">+</button>
      </div>
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="closeCreateEntityDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Create Failure Effect</button>
      </div>
    </form>
    }
  </div>
</div>
}

@if (showEditComponentTempDialog()) {
<div class="modal" (click)="closeEditComponentTempDialog()">
  <div class="modal-content modal-content--compact" (click)="$event.stopPropagation()">
    <h2>Edit Component Temperature</h2>
    <p>{{ editComponentForm.controls.componentDesignator.value }}</p>
    <form [formGroup]="editComponentForm" (ngSubmit)="updateComponentTemp()" class="form-stack">
      <label>
        <span>Component</span>
        <input type="text" formControlName="componentDesignator" readonly />
      </label>
      <label>
        <span>Operating temp (°C)</span>
        <input type="number" step="0.1" formControlName="opTemp" placeholder="Operating temp" />
      </label>
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="closeEditComponentTempDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Update Temperature</button>
      </div>
    </form>
  </div>
</div>
}

@if (showEditCoverageDialog()) {
<div class="modal" (click)="closeEditCoverageDialog()">
  <div class="modal-content modal-content--compact" (click)="$event.stopPropagation()">
    <h2>Edit Diagnostic Coverage</h2>
    <form [formGroup]="editCoverageForm" (ngSubmit)="updateCoverage()" class="form-stack">
      <label>
        <span>Coverage link</span>
        <select formControlName="coverageLinkKey" (change)="syncCoverageSelection()">
          <option value="">Select existing coverage link</option>
          @for (link of coverageLinks(); track link) {
          <option [value]="link.safety_mechanism_id + '::' + link.failure_instance_id">
            {{ link.safety_mechanism_id }} -> {{ link.failure_instance_id }}
          </option>
          }
        </select>
      </label>
      <input type="text" formControlName="safetyMechanismId" placeholder="Safety mechanism id" readonly />
      <input type="text" formControlName="failureInstanceId" placeholder="Failure instance id" readonly />
      <label>
        <span>Mechanism type</span>
        <select formControlName="mechanismType">
          <option value="SPF">Primary (SPF)</option>
          <option value="LATENT">Secondary (Latent)</option>
        </select>
      </label>
      <input type="number" step="0.01" min="0" max="1" formControlName="diagnosticCoverage"
        placeholder="Diagnostic coverage" />
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="closeEditCoverageDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Update Coverage</button>
      </div>
    </form>
  </div>
</div>
}

@if (showEditFailureLinkDialog()) {
<div class="modal" (click)="closeEditFailureLinkDialog()">
  <div class="modal-content modal-content--wide" (click)="$event.stopPropagation()">
    <h2>Edit Failure Link</h2>
    <form [formGroup]="editFailureLinkForm" (ngSubmit)="updateFailureLinkRecord()" class="form-stack">
      <label>
        <span>Failure Instance</span>
        <input type="text" formControlName="failureInstanceId" readonly />
      </label>
      <label>
        <span>Component</span>
        <input type="text" formControlName="componentDesignator" readonly />
      </label>
      <label>
        <span>Failure mode</span>
        <input type="text" formControlName="failureModeCode" readonly />
      </label>
      <label>
        <span>Failure Effect</span>
        <select formControlName="failureEffectId" (change)="syncEditFailureLinkFailureEffect()">
          <option value="">None</option>
          @for (fe of failureEffects(); track fe) {
          <option [value]="fe.id">{{ fe.id }} - {{ fe.name }}</option>
          }
        </select>
      </label>
      <label>
        <span>System Effect</span>
        <select formControlName="systemEffectId" (change)="syncEditFailureLinkSystemEffect()">
          <option value="">None</option>
          @for (se of systemEffects(); track se) {
          <option [value]="se.id">{{ se.id }} - {{ se.name }}</option>
          }
        </select>
      </label>
      <label>
        <span>Safety Goal</span>
        <select formControlName="safetyGoalId">
          <option value="">None</option>
          @for (sg of safetyGoals(); track sg) {
          <option [value]="sg.id">{{ sg.id }} - {{ sg.description }}</option>
          }
        </select>
      </label>
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="closeEditFailureLinkDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Save Failure Link</button>
      </div>
    </form>
  </div>
</div>
}

@if (showEditSafetyMechanismDialog()) {
<div class="modal" (click)="closeEditSafetyMechanismDialog()">
  <div class="modal-content modal-content--compact" (click)="$event.stopPropagation()">
    <h2>Edit Safety Mechanism</h2>
    <form [formGroup]="editCoverageForm" (ngSubmit)="updateCoverage()" class="form-stack">
      <label>
        <span>Safety Mechanism</span>
        <input type="text" formControlName="safetyMechanismId" readonly />
      </label>
      <label>
        <span>Failure Instance</span>
        <input type="text" formControlName="failureInstanceId" readonly />
      </label>
      <label>
        <span>Mechanism type</span>
        <select formControlName="mechanismType">
          <option value="SPF">Primary (SPF)</option>
          <option value="LATENT">Secondary (Latent)</option>
        </select>
      </label>
      <label>
        <span>Diagnostic coverage</span>
        <input type="number" step="0.01" min="0" max="1" formControlName="diagnosticCoverage"
          placeholder="Diagnostic coverage" />
      </label>
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary"
          (click)="closeEditSafetyMechanismDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Save Safety Mechanism</button>
      </div>
    </form>
  </div>
</div>
}

@if (showEditFeLinkDialog()) {
<div class="modal" (click)="closeEditFeLinkDialog()">
  <div class="modal-content modal-content--compact" (click)="$event.stopPropagation()">
    <h2>Edit Failure Effect → System Effect</h2>
    <form [formGroup]="editFeLink" (ngSubmit)="updateFailureEffectLink()" class="form-stack">
      <label>
        <span>Failure Effect</span>
        <select formControlName="failureEffectId" (change)="syncFeLinkSelection()">
          <option value="">Select failure effect</option>
          @for (fe of failureEffects(); track fe) {
          <option [value]="fe.id">
            {{ fe.id }} - {{ fe.name }}
            @if (fe.system_effect_id) {
            &rarr; {{ fe.system_effect_id }}
            }
          </option>
          }
        </select>
      </label>
      <label>
        <span>New target System Effect</span>
        <select formControlName="systemEffectId">
          <option value="">None (remove link)</option>
          @for (se of systemEffects(); track se) {
          <option [value]="se.id">
            {{ se.id }} - {{ se.name }}
          </option>
          }
        </select>
      </label>
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="closeEditFeLinkDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Update FE Link</button>
      </div>
    </form>
  </div>
</div>
}

@if (showEditSeLinkDialog()) {
<div class="modal" (click)="closeEditSeLinkDialog()">
  <div class="modal-content modal-content--compact" (click)="$event.stopPropagation()">
    <h2>Edit System Effect → Safety Goal</h2>
    <form [formGroup]="editSeLink" (ngSubmit)="updateSystemEffectLink()" class="form-stack">
      <label>
        <span>System Effect</span>
        <select formControlName="systemEffectId" (change)="syncSeLinkSelection()">
          <option value="">Select system effect</option>
          @for (se of systemEffects(); track se) {
          <option [value]="se.id">
            {{ se.id }} - {{ se.name }}
            @if (se.safety_goal_id) {
            &rarr; {{ se.safety_goal_id }}
            }
          </option>
          }
        </select>
      </label>
      <label>
        <span>New target Safety Goal</span>
        <select formControlName="safetyGoalId">
          <option value="">None (remove link)</option>
          @for (sg of safetyGoals(); track sg) {
          <option [value]="sg.id">
            {{ sg.id }} - {{ sg.description }}
          </option>
          }
        </select>
      </label>
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="closeEditSeLinkDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Update SE Link</button>
      </div>
    </form>
  </div>
</div>
}

@if (showEditFiCauseDialog()) {
<div class="modal" (click)="closeEditFiCauseDialog()">
  <div class="modal-content modal-content--compact" (click)="$event.stopPropagation()">
    <h2>Edit Failure Instance → Failure Effect</h2>
    <form [formGroup]="editFiCause" (ngSubmit)="updateFailureInstanceCause()" class="form-stack">
      <label>
        <span>Failure Instance</span>
        <select formControlName="failureInstanceId" (change)="syncFiCauseSelection()">
          <option value="">Select failure instance</option>
          @for (fi of failureInstances(); track fi) {
          <option [value]="fi.id">
            {{ fi.id }} - {{ fi.name }}
            @if (fi.failure_effect_id) {
            &rarr; {{ fi.failure_effect_id }}
            }
          </option>
          }
        </select>
      </label>
      <label>
        <span>New target Failure Effect</span>
        <select formControlName="failureEffectId">
          <option value="">None (remove link)</option>
          @for (fe of failureEffects(); track fe) {
          <option [value]="fe.id">
            {{ fe.id }} - {{ fe.name }}
          </option>
          }
        </select>
      </label>
      <div class="modal-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="closeEditFiCauseDialog()">Cancel</button>
        <button type="submit" class="btn btn-primary">Update FI Cause</button>
      </div>
    </form>
  </div>
</div>
}

@if (showClearDbModal) {
<div class="modal">
  <div class="modal-content">
    <h2>Clear Database Data</h2>
    <p>Select the data types you want to delete from the database. Note that deleting nodes may also remove any
      relationships associated with them.</p>
    <div class="checkbox-list modal-checkbox-list">
      <label><input type="checkbox" [(ngModel)]="clearSelections.Project"> Projects</label>
      <label><input type="checkbox" [(ngModel)]="clearSelections.Component"> Components</label>
      <label><input type="checkbox" [(ngModel)]="clearSelections.FailureInstance"> Failure Instances</label>
      <label><input type="checkbox" [(ngModel)]="clearSelections.FailureEffect"> Failure Effects</label>
      <label><input type="checkbox" [(ngModel)]="clearSelections.SystemEffect"> System Effects</label>
      <label><input type="checkbox" [(ngModel)]="clearSelections.SafetyGoal"> Safety Goals</label>
      <label><input type="checkbox" [(ngModel)]="clearSelections.SafetyMechanism"> Safety Mechanisms</label>
    </div>
    <div class="modal-confirmation">
      <label>
        <input type="checkbox" [(ngModel)]="clearConfirmation">
        <strong>I understand this will permanently delete the selected data types and their connected
          relations.</strong>
      </label>
    </div>
    <div class="modal-actions">
      <button type="button" class="btn btn-outline-secondary" (click)="showClearDbModal = false">Cancel</button>
      <button type="button" class="btn btn-danger" [disabled]="!clearConfirmation || !hasClearSelection()"
        (click)="confirmClearDatabase()">Clear Selected Data</button>
    </div>
  </div>
</div>
}